import type { ActionsOfCreators, FeatureHandler } from '../helpers';

import { unconfirmed } from './unconfirmed';
import { checkIn } from './checkIn';

export const inputActions = [unconfirmed, checkIn];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
